import {action} from 'mobx';
import {BaseModel} from "./base-model";
import {BaseDomainModel} from "./base-domain-model";

export class BaseViewModel extends BaseModel {
  domainModel: BaseDomainModel;
  sortIndex: Number;

  constructor(domainModel: BaseDomainModel) {
    super(domainModel);

    this.sortIndex = -1;
    this.domainModel = domainModel;
  }

  get id(): Number {
    return this.domainModel?.id;
  }

  get name(): String {
    return this.domainModel?.name;
  }

  @action update(model) {
    this.domainModel.update(model);
  }
}
